import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('CustomChannelMessageOutgoingAttachment').extend('Uuid');

Factory.define('CustomChannelMessageOutgoingAttachmentWithDefaults')
  .extend('CustomChannelMessageOutgoingAttachment')
  .attr('contentType', 'text/plain')
  .attr('filename', 'some-outgoing-facebook-attachment.txt');
